// import { LocaleProvider } from 'antd';

// import antdEnUS from 'antd/es/locale/en_US';
// import antdUrPK from 'antd/es/locale/ur_PK';
// import antdEsMX from 'antd/es/locale/es_ES';
// import en from './locales/en_US.json'
// import enGF from './locales/en_US_GreenFuel.json'
// import ur from './locales/ur_PK.json'
// import es from './locales/es_MX.json'
// import i18n from 'i18next'
// import { initReactI18next } from 'react-i18next'
// import { THEME_CONFIG } from 'configs/AppConfig';
// import { DIR_LTR, DIR_RTL } from 'constants/ThemeConstant';
// import { getUserData, useUserData } from 'components/UserDataContext/UserDataContext';

// const data = getUserData();
// const resources = {
//     en: {
//         translation: en,
//         antd: antdEnUS,
//         direction: DIR_LTR,
//     },
//     ur: {
//         translation: ur,
//         antd: antdUrPK,
//         direction: DIR_RTL,
//     },
//     es: {
//         translation: es,
//         antd: antdEsMX,
//         direction: DIR_LTR,
//     },
//     // zh: {
//     //     translation: zh,
//     //     antd: antdZhCn
//     // },
//     // fr: {
//     //     translation: fr,
//     //     antd: antdFrFR
//     // },
//     // ja: {
//     //     translation: ja,
//     //     antd: antdJaJP
//     // },
// }
// export const getLangResources = (isGreenFuel) => {
//     return {
//         en: {
//             translation: isGreenFuel ? enGF : en,
//             antd: antdEnUS,
//             direction: DIR_LTR,
//         },
//         ur: {
//             translation: ur,
//             antd: antdUrPK,
//             direction: DIR_RTL,
//         },
//         es: {
//             translation: es,
//             antd: antdEsMX,
//             direction: DIR_LTR,
//         },
//         // zh: {
//         //     translation: zh,
//         //     antd: antdZhCn
//         // },
//         // fr: {
//         //     translation: fr,
//         //     antd: antdFrFR
//         // },
//         // ja: {
//         //     translation: ja,
//         //     antd: antdJaJP
//         // },
//     }
// }
// i18n.use(initReactI18next).init({
//     resources,
//     fallbackLng: THEME_CONFIG.locale,
//     lng: THEME_CONFIG.locale,
//     interpolation: {
//         escapeValue: false 
//     }
// })

// export default i18n;




import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { THEME_CONFIG } from 'configs/AppConfig';
import antdEnUS from 'antd/es/locale/en_US';
import antdFrFR from 'antd/es/locale/fr_FR';
import antdEsES from 'antd/es/locale/es_ES';
import antdUrPK from 'antd/es/locale/ur_PK';
import antdPtBR from 'antd/es/locale/pt_BR';
import antdThTH from 'antd/es/locale/th_TH';
import { DIR_LTR, DIR_RTL } from 'constants/ThemeConstant';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import 'dayjs/locale/pt';
import 'dayjs/locale/fr';
import 'dayjs/locale/th';

export const getDataByLanguage = (lang, isGreenFuel = false) => {
  const langKey = lang + (isGreenFuel && lang === 'en_US' ? '_GreenFuel' : '');

  switch (langKey) {
    case 'ur':
    case 'ur_PK':
      return { antd: antdUrPK, direction: DIR_RTL };
    case 'es':
    case 'es_ES':
    case 'es_MX':
      return { antd: antdEsES, direction: DIR_LTR };
    case 'fr':
    case 'fr_FR':
      return { antd: antdFrFR, direction: DIR_LTR };
    case 'pt_BR':
    case 'pt':
      return { antd: antdPtBR, direction: DIR_LTR };
    case 'th_TH':
    case 'th':
      return { antd: antdThTH, direction: DIR_LTR };
    case 'en_US':
    default:
      return { antd: antdEnUS, direction: DIR_LTR };
  }
};
// i18next is set up once (index.js). A later call, from AppLayout when the company's wording
// file is known, only switches the file and reloads it in the current language. Setting it up
// a second time reset the language to English whenever the user's language had already been
// applied, which happens when the user data loads quickly.
// Dates and numbers follow the chosen language (QA UI-24): dayjs month and day names, and
// the locale numbers are grouped with (es and pt 1.000.000, fr 1 000 000).
const DAYJS_LOCALE = { en: 'en', es: 'es', pt: 'pt', fr: 'fr', th: 'th', ur: 'en' };
const NUMBER_LOCALE = { en: 'en-US', es: 'es-ES', pt: 'pt-BR', fr: 'fr-FR', th: 'th-TH', ur: 'en-US' };
const shortLang = (lng) => (lng || 'en').toString().slice(0, 2).toLowerCase();
// While an Excel file is built, figures are written as plain numbers (see withPlainNumbers), so
// Excel receives numbers it can add up and sort, whatever the language.
let plainNumbers = false;
export const isPlainNumbersMode = () => plainNumbers;
/** Runs fn with figures formatted as plain numbers (en-US, no grouping where it matters). */
export const withPlainNumbers = (fn) => {
  plainNumbers = true;
  try {
    return fn();
  } finally {
    plainNumbers = false;
  }
};
/** The locale to pass to toLocaleString / Intl.NumberFormat for the current language. */
export const numberLocale = () => (plainNumbers ? 'en-US' : NUMBER_LOCALE[shortLang(i18n.language)] || 'en-US');
const applyDayjsLocale = (lng) => dayjs.locale(DAYJS_LOCALE[shortLang(lng)] || 'en');
i18n.on('languageChanged', applyDayjsLocale);

let started = false;
const savedLanguage = () => {
  try {
    return localStorage.getItem('lang_key') || 'en';
  } catch (e) {
    return 'en';
  }
};
const loadPathFor = (isGreenFuel) =>
  `${process.env.PUBLIC_URL}/lang/locales/{{lng}}/${isGreenFuel ? 'translation_GreenFuel' : 'translation'}.json`;

export const initI18n = (isGreenFuel = true) => {
  const loadPath = loadPathFor(isGreenFuel);
  if (!started) {
    started = true;
    i18n.use(HttpBackend).use(initReactI18next).init({
      // Start in the language the user chose last time (saved by the language switch), so
      // the first render after a reload is already in that language.
      lng: savedLanguage(),
      fallbackLng: ['en', 'es', 'fr', 'ur'],
      debug: process.env.NODE_ENV !== 'production',
      backend: { loadPath },
      interpolation: { escapeValue: false },
    });
    return;
  }
  const switchFile = () => {
    const backend = i18n.services?.backendConnector?.backend;
    if (i18n.options.backend?.loadPath === loadPath && backend?.options?.loadPath === loadPath) return;
    i18n.options.backend = { ...i18n.options.backend, loadPath };
    if (backend?.options) backend.options.loadPath = loadPath;
    const lng = i18n.language;
    i18n.reloadResources().then(() => i18n.changeLanguage(lng));
  };
  if (i18n.isInitialized) switchFile();
  else i18n.on('initialized', switchFile);
};
export default i18n;





